module.exports = __webpack_public_path__ + "static/media/dark-theme-geofence-alt.509a2b35.svg";